// extracted by mini-css-extract-plugin
export default {"header":"Header_header__PU+qa","logo":"Header_logo__hm2M-","score":"Header_score__CaQyQ","score__heading":"Header_score__heading__gTGVA","score__text":"Header_score__text__wdlRH"};